// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { ArrayPage } from "../../core/pagination.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Messages extends APIResource {
    create(agentID, body, options) {
        return this._client.post(path `/v1/agents/${agentID}/messages`, {
            body,
            ...options,
            stream: body.streaming ?? false,
        });
    }
    /**
     * Retrieve message history for an agent.
     */
    list(agentID, query = {}, options) {
        return this._client.getAPIList(path `/v1/agents/${agentID}/messages`, (ArrayPage), {
            query,
            ...options,
        });
    }
    /**
     * Cancel runs associated with an agent. If run_ids are passed in, cancel those in
     * particular.
     *
     * Note to cancel active runs associated with an agent, redis is required.
     */
    cancel(agentID, body = {}, options) {
        return this._client.post(path `/v1/agents/${agentID}/messages/cancel`, { body, ...options });
    }
    /**
     * Summarize an agent's conversation history.
     */
    compact(agentID, body = {}, options) {
        return this._client.post(path `/v1/agents/${agentID}/summarize`, { body, ...options });
    }
    /**
     * Asynchronously process a user message and return a run object. The actual
     * processing happens in the background, and the status can be checked using the
     * run ID.
     *
     * This is "asynchronous" in the sense that it's a background run and explicitly
     * must be fetched by the run ID.
     *
     * **Note:** Sending multiple concurrent requests to the same agent can lead to
     * undefined behavior. Each agent processes messages sequentially, and concurrent
     * requests may interleave in unexpected ways. Wait for each request to complete
     * before sending the next one. Use separate agents or conversations for parallel
     * processing.
     */
    createAsync(agentID, body, options) {
        return this._client.post(path `/v1/agents/${agentID}/messages/async`, { body, ...options });
    }
    /**
     * Resets the messages for an agent
     */
    reset(agentID, body, options) {
        return this._client.patch(path `/v1/agents/${agentID}/reset-messages`, { body, ...options });
    }
    /**
     * Process a user message and return the agent's response.
     *
     * Deprecated: Use the `POST /{agent_id}/messages` endpoint with `streaming=true`
     * in the request body instead.
     *
     * **Note:** Sending multiple concurrent requests to the same agent can lead to
     * undefined behavior. Each agent processes messages sequentially, and concurrent
     * requests may interleave in unexpected ways. Wait for each request to complete
     * before sending the next one. Use separate agents or conversations for parallel
     * processing.
     *
     * This endpoint accepts a message from a user and processes it through the agent.
     * It will stream the steps of the response always, and stream the tokens if
     * 'stream_tokens' is set to True.
     *
     * @deprecated
     */
    stream(agentID, body, options) {
        return this._client.post(path `/v1/agents/${agentID}/messages/stream`, {
            body,
            ...options,
            stream: true,
        });
    }
}
//# sourceMappingURL=messages.mjs.map